

import React from 'react';

const KidsMenu = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="kidsMenu" className="min-h-screen p-8 text-center">
      <h2 className="h2 text-4xl font-bold">Pricing & Stripe</h2>
      <p className="pretitle text-lg">When You win, we win</p>
      <div className='grid grid-row'>
        <span></span>
        <div className="h9 text-neutral-700 italic underline mt-8 mb-3">
          Pricing
        </div>
        <span className='font-bold'>
          There is <u>NO</u> fixed monthly/yearly price. All that we ask for is <span className='pretitle text-lg'>50¢</span> per POS card transaction <u> on top of Stripe's industry standard trasnaction fee of 2.7% + 5¢.</u> That's it. No startup or hidden fees.
        </span>
        <br />
        <span className='font-bold text-red-900 text-xl'>
          <u>30% Off Discount</u>
        </span>
        <span className='font-bold'>
          {' '}We are offering <span className='pretitle'>35¢ </span>per POS card transaction for a year to restaurants that refer another business to GoHost that succesfully converts!
        </span>
        <span className="text-green-800">If you averaged 50 transactions per day...</span>
        <div className="bg-lime-100 border border-green-700 rounded-xl grid gap-3 w-full pretitle text-lg grid-cols-[1fr,30px,1fr]">
          <div className="rounded-md p-2 grid text-right">
            <span>Base Rate</span>
            <span>50 × $0.50 = $25.00 / day</span>
            <span>
              $25.00 × 365 days ={' '}
              <span className='text-xl'>$9,125.00 / year</span>
            </span>
          </div>

          <div className="p-2 text-center">
            <span>Vs.</span>
          </div>

          <div className="p-2 grid text-left">
            <span className='text-green-800'>Discounted Rate</span>
            <span>50 × $0.35 = $17.50 / day</span>
            <span>
              $17.50 × 365 days ={' '}
              <span className='pretitle text-green-800 text-2xl underline'>
                $6,387.50 / year
              </span>
            </span>
          </div>
        </div>
        <span className='font-bold'>Year long discounts can be extended if more referals are given and converted. GoHost will always strive for this ~help us help you~ relationship!</span>
        <span className='font-bold'>*Discount will cease to be honored if referred client ends relationship in that year*</span>

        <br />
        <span>
          The GoHost POS app is built to run on any Android device running Android 8.0 or later that supports Bluetooth Low Energy. You will have the responsibility of in-house devices. We see an advantage in enabling restaurants to use whatever screen sizes and mobility they prefer – whether that be one or two central order trackers, or every server with a small tablet – GoHost is setup to handle it all.
        </span>
      </div>
      <br />
      <div className="h9 text-neutral-700 italic underline mt-8 mb-3">
        Stripe Connect
      </div>
      <span>
        To complete your GoHost Account setup, you will connect a bank account to Stripe Connect, a powerful and secure payment infrastructure that helps you manage transactions smoothly. Here’s what that means for you:
      </span>
      <br />
      <div className="mt-8 text-center">
        <ul className="list-disc inline-block text-left space-y-2">
          <li>
            <span className="font-bold">Seamless POS Setup:</span> The GoHost App comes with Stripe functionality built in, so setting up your POS devices for a fast, smooth payment process is a breeze.
          </li>
          <li>
            <span className="font-bold">Terminal Ready</span> Use your preferred Android device along with a simple Stripe card reader for secure, reliable payments.
          </li>
          <li>
            <span className="font-bold">Automatic Transaction Fee Inclusion:</span> Each transaction automatically includes our transaction fee.
          </li>
          <li>
            <span className="font-bold">Enhanced Security &amp; PCI Compliance:</span> Stripe processes all payment data in a PCI-compliant environment, reducing your compliance burden.
          </li>
          <li>
            <span className="font-bold">Transparent Payment Details &amp; Record Keeping:</span> Detailed payment records and reporting simplify your bookkeeping and financial reconciliation.
          </li>
          <li>
            <span className="font-bold">Customizable Payouts &amp; Reporting:</span> Manage payout schedules and generate reports to better track revenue and cash flow.
          </li>
          <li>
            <span className="font-bold">Future-Proof &amp; Scalable:</span> As your business grows, Stripe Connect scales with you, supporting additional features and payment options.
          </li>
          <li>
            <span className="font-bold">Legal &amp; Compliance Considerations:</span> Clear payment details, transparent fee structures, and record keeping ensure compliance and help safeguard both parties.
          </li>
        </ul>
      </div>
      <br />
      <span>
        <u>Hardware Requirements</u>
        <br/>
        <ul>
          <li>
            <span className="font-bold">Minimum Android Version:</span> Stripe’s Android SDK typically requires Android 8.0 (API 26) or higher.
          </li>
          <li>
            <span className="font-bold">Bluetooth Low Energy (BLE)</span> Since most Stripe readers (like the Stripe M2) connect via Bluetooth, the device must support BLE.
          </li>
          <li>
            <span className="font-bold">Hardware Considerations:</span> Devices should have sufficient processing power and a stable Bluetooth radio for smooth pairing and communication with the Stripe card reader.
          </li>
        </ul>
      </span>
      <br/>
      <span></span>
      <br/>
      <span>
        You retain control over your Stripe Connect account, ensuring all transaction data is accurately recorded for legal and tax purposes.
      </span>
      <br />
      <span>
        We ensure that our integration meets all security standards and that our fee structure is transparent. We work with you to clearly outline responsibilities, making sure both parties understand and comply with relevant financial regulations.     
      </span>
      <br />
      <span>
        By leveraging Stripe Connect, our POS system not only delivers a seamless and secure payment experience but also provides powerful tools to manage and analyze your transactions—so you can focus on what matters most: serving your guests.       
      </span>
    </section>
  );
});

export default KidsMenu;
